<form [formGroup]="paramFormDauV5" *ngIf="!readOnly">
    <div class="input-cont">
        <mat-form-field>
            <input matInput [placeholder]="'SCREW_TERMINAL_BLOCK' | translate" (focus)="havingValue = true"
                   formControlName="screwTerminalBlock">
        </mat-form-field>
        <div class="hint"
             *ngIf="!paramFormDauV5.controls.screwTerminalBlock.value">{{'DEFAULT_SCREW_TERMINAL_BLOCK_VALUE_MESSAGE' | translate}}
        </div>
        <button mat-button class="btn btn-light" *ngIf="paramFormDauV5.controls.screwTerminalBlock.value && paramFormDauV5.controls.screwTerminalBlock.value !== deviceUid"
                (click)="setUidAsSTBValue()">
            {{'APPLY_UID_VALUE' | translate}}
        </button>
    </div>
</form>


<form [formGroup]="paramFormDauV5" *ngIf="readOnly">
    <mat-form-field class="readonly">
        <input matInput [placeholder]="'SCREW_TERMINAL_BLOCK' | translate" [readonly]="true"
               [value]="paramFormDauV5.controls.screwTerminalBlock.value || deviceUid">
    </mat-form-field>
</form>
